var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.9C3.5 9.05992 3.5 8.63988 3.66349 8.31901C3.8073 8.03677 4.03677 7.8073 4.31901 7.66349C4.63988 7.5 5.05992 7.5 5.9 7.5H8.31332C8.74409 7.5 8.95947 7.5 9.14963 7.56559C9.31778 7.62359 9.47094 7.71825 9.59801 7.84272C9.74171 7.98347 9.83803 8.17612 10.0307 8.56142L10.9693 10.439C11.162 10.8243 11.2583 11.0169 11.402 11.1577C11.5291 11.2821 11.6822 11.3768 11.8504 11.4348C12.0405 11.5004 12.2559 11.5004 12.6867 11.5004H18.1C18.9401 11.5004 19.3601 11.5004 19.681 11.6639C19.9632 11.8077 20.1927 12.0372 20.3365 12.3194C20.5 12.6403 20.5 13.0603 20.5 13.9004V18.1004C20.5 18.9405 20.5 19.3605 20.3365 19.6814C20.1927 19.9636 19.9632 20.1931 19.681 20.3369C19.3601 20.5004 18.9401 20.5004 18.1 20.5004H5.9C5.05992 20.5004 4.63988 20.5004 4.31901 20.3369C4.03677 20.1931 3.8073 19.9636 3.66349 19.6814C3.5 19.3605 3.5 18.9405 3.5 18.1004V9.9Z",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11V7.16274C17.5 6.91815 17.5 6.79586 17.4724 6.68077C17.4479 6.57873 17.4075 6.48119 17.3526 6.39172C17.2908 6.2908 17.2043 6.20432 17.0314 6.03137L14.9686 3.96863C14.7957 3.79568 14.7092 3.7092 14.6083 3.64736C14.5188 3.59253 14.4213 3.55213 14.3192 3.52763C14.2041 3.5 14.0818 3.5 13.8373 3.5H8.9C8.05992 3.5 7.63988 3.5 7.31901 3.66349C7.03677 3.8073 6.8073 4.03677 6.66349 4.31901C6.5 4.63988 6.5 5.05992 6.5 5.9V8",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5L13.5 5.9C13.5 6.46005 13.5 6.74008 13.609 6.95399C13.7049 7.14215 13.8578 7.29513 14.046 7.39101C14.2599 7.5 14.5399 7.5 15.1 7.5L17.5 7.5",
    stroke: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.9eea4da1f6ec7c1cc6cbde4439755c3d.svg";
export { ForwardRef as ReactComponent };